// extracted by mini-css-extract-plugin
module.exports = {"base":"LoadingFallBack_base__18tRW"};